import { Fragment, type ReactNode } from "react";
import Schedule from "@mui/icons-material/Schedule";
import HourglassBottom from "@mui/icons-material/HourglassBottom";
import Sync from "@mui/icons-material/Sync";
import Announcement from "@mui/icons-material/Announcement";
import type { TransportInformation as TruckInfo } from "../types";
import { xBFormatter } from "./orderHistoryFormatting";

export function createSingleDeliveryText(
  tt: TruckInfo,
  extended?: false,
  extraTakt?: false | number,
  duration?: "FULL" | "HALF" | "ROUND" | "INVALID",
): string;
export function createSingleDeliveryText(
  tt: TruckInfo,
  extended: true,
  extraTakt?: false | number,
  duration?: "FULL" | "HALF" | "ROUND" | "INVALID",
): ReactNode[];
export function createSingleDeliveryText(
  tt: TruckInfo,
  extended: boolean,
  extraTakt?: false | number,
  duration?: "FULL" | "HALF" | "ROUND" | "INVALID",
): string | ReactNode[];
export function createSingleDeliveryText(
  tt: TruckInfo,
  extended: boolean = false,
  extraTakt: false | number = false,
  duration: "FULL" | "HALF" | "ROUND" | "INVALID" = "INVALID",
): string | ReactNode[] {
  const truckAmount = tt.amount;

  const hereTakt = tt.specialTakt ?? extraTakt;

  let truckTypeStr =
    (tt.thermo ? "Thermo-" : "") +
    ({
      "3A": "Dreiachser",
      "2A": "Zweiachser",
      "4A": "Vierachser",
      SA: "Sattel",
      "3A4A": "Solo",
      HZ: "Hängerzug",
      XX: "",
      KR: "Kran-LKW",
      TL: "Tieflader",
    }[tt.type] || "LKW");

  if (tt.allrad) {
    truckTypeStr = (truckTypeStr || "LKW") + " allrad";
  }

  if (tt.stahlmulde) {
    truckTypeStr = (truckTypeStr || "LKW") + " Stahlmulde";
  }

  if (tt.bordmatik) {
    truckTypeStr = (truckTypeStr || "LKW") + " Bordmatik";
  }

  const extension = [];

  if (extended) {
    if (tt.specialFirstUnload) {
      extension.push(
        <Fragment>
          <Schedule fontSize="inherit" />
          {!tt.specialFirstUnload.startsWith("x")
            ? tt.specialFirstUnload
            : tt.specialFirstUnload.startsWith("xB")
              ? xBFormatter(tt.specialFirstUnload, "INFO", false)
              : tt.specialFirstUnload === "xAM"
                ? "vormittags"
                : tt.specialFirstUnload === "xPM"
                  ? "nachmittags"
                  : "???"}
        </Fragment>,
      );
    }
    if (hereTakt || hereTakt === 0) {
      extension.push(
        <Fragment>
          <HourglassBottom fontSize="inherit" />
          {hereTakt > 0 ? hereTakt + " min Takt" : "kein Takt"}
        </Fragment>,
      );
    }
    if (tt.specialDurationUnit) {
      extension.push(
        <Fragment>
          <Sync fontSize="inherit" />
          {tt.specialDurationValue}{" "}
          {tt.specialDurationUnit === "ROUNDS" ? "Rd." : "h"}
        </Fragment>,
      );
    } else if (tt.specialDuration && tt.specialDuration !== "FULL") {
      extension.push(
        <Fragment>
          <Sync fontSize="inherit" />
          {tt.specialDuration === "HALF" ? "1/2 Tag" : "1 Rd."}
        </Fragment>,
      );
    } else if (tt.siteWork && duration !== "INVALID") {
      extension.push(
        <Fragment>
          <Sync fontSize="inherit" />
          {duration === "FULL" ? "8h" : duration === "HALF" ? "4h" : "1 Rd."}
        </Fragment>,
      );
    }
    if (tt.specialComment) {
      extension.push(
        <Fragment>
          <Announcement fontSize="inherit" />
          {tt.specialComment}
        </Fragment>,
      );
    }
  }

  const out = !truckAmount
    ? truckTypeStr
    : truckAmount +
      " " +
      (truckTypeStr || "LKW") +
      (tt.siteWork ? " (Bstd.)" : "");
  if (extended) return [out, ...extension];
  return out;
}
